export enum AlignType {
  Left = "LEFT",
  Center = "CENTER",
  Right = "RIGHT",
}
